import { memo } from "react";
import { Pressable } from "react-native";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import type { LessonSortOption, LessonSortType, SortOrder } from "./types";

type Props = {
	sortOptions: LessonSortOption[];
	sortType: LessonSortType;
	sortOrder: SortOrder;
	onPress: () => void;
};

export const SortButton = memo(
	({ sortOptions, sortType, sortOrder, onPress }: Props) => {
		const theme = useAppTheme();
		const { isMobile } = useDevice();

		const sortIcon = sortOrder === "asc" ? "sort-ascending" : "sort-descending";
		const activeOption = sortOptions.find((item) => item.type === sortType);
		const sortLabel = activeOption?.buttonLabel ?? activeOption?.label ?? "";

		return (
			<Pressable
				onPress={onPress}
				accessibilityRole="button"
				accessibilityLabel={sortLabel}
			>
				<Box
					flexDirection="row"
					alignItems="center"
					paddingRight={isMobile ? 16 : 0}
					gap={8}
				>
					<CustomListSubheader enableGutters={false}>
						{sortLabel}
					</CustomListSubheader>
					<AppIcon
						name={sortIcon}
						size={18}
						color={theme.colors.onSurfaceVariant}
					/>
				</Box>
			</Pressable>
		);
	},
);

SortButton.displayName = "SortButton";
